import OnboardingActionsSection from "./OnboardingActionsSection";
import OnboardingProgressSection from "./OnboardingProgressSection";
import OnboardingResourcesSection from "./OnboardingResourcesSection";

const OnboardingContent = () => (
  <div className="gap-md grid grid-cols-3">
    <OnboardingActionsSection />
    <OnboardingProgressSection />
    <OnboardingResourcesSection />
  </div>
);

export default OnboardingContent;
